export const AdVideoExamplePrompt = [
  "Restaurant",
  "Cafe",
  "Coffee Shop",
  "Bakery",
  "Fast Food Restaurant",
  "Food Truck",
  "Catering Service",
  "Bubble Tea Shop",
  "Ice Cream Shop",
  "Clothing Store",
  "Fashion Boutique",
  "Online Store",
  "Electronics Store",
  "Furniture Store",
  "Grocery Store",
  "Bookstore",
  "Jewelry Store",
  "Beauty Salon",
  "Barbershop",
  "Spa",
  "Nail Salon",
  "Fitness Center",
  "Yoga Studio",
  "Dental Clinic",
  "Medical Clinic",
  "Pharmacy",
  "Veterinary Clinic",
  "Accounting Firm",
  "Law Firm",
  "Insurance Agency",
  "Real Estate Agency",
  "Marketing Agency",
  "AI Automation Company",
  "Software Development Company",
  "IT Services Company",
  "Consulting Firm",
  "Recruitment Agency",
  "School",
  "Tuition Center",
  "Language Academy",
  "Training Center",
  "Property Development Company",
  "Interior Design Firm",
  "Renovation Company",
  "Cleaning Service",
  "Plumbing Service",
  "Electrical Service",
  "Landscaping Company",
  "Car Dealership",
  "Car Rental Company",
  "Auto Repair Shop",
  "Car Detailing Service",
  "Hotel",
  "Resort",
  "Travel Agency",
  "Tour Company",
  "SaaS Company",
  "AI Company",
  "Fintech Company",
  "Cybersecurity Company",
  "Mobile App Company",
  "Cloud Services Company",
  "Data Analytics Company",
  "Logistics Company",
  "Manufacturing Company",
  "Construction Company",
  "Printing Company",
  "Event Management Company",
  "Photography Studio",
  "Video Production Company",
  "E-Commerce Brand",
  "Pet Grooming Business",
  "Childcare Center",
  "Non-Profit Organization",
  "Startup",
  "Small Business",
  "Local Business",
  "Enterprise Company",
  "Franchise Business",
  "Online Business",
  "Home-Based Business",
  "Wholesale Business",
  "Import & Export Business",
  "Digital Agency",
  "Creative Agency",
  "Healthcare Provider",
  "Financial Services Company",
  "Technology Company",
  "Retail Business",
  "Service-Based Business",
  "Professional Services Firm",
  "Educational Institution",
  "Hospitality Business",
  "Entertainment Company",
  "Telecommunications Company",
  "Renewable Energy Company",
  "Agricultural Business",
  "Food & Beverage Business",
  "Luxury Brand",
  "Personal Brand",
  "Influencer Business",
  "Creator Business",
  "Subscription-Based Business",
  "Marketplace Platform",
  "AI Agent Development Company",
  "Business Automation Company",
  "Customer Support Outsourcing Company",
  "Virtual Assistant Service",
  "BPO Company",
  "Co-Working Space",
  "Event Venue",
  "Wedding Planning Company",
  "Security Services Company",
  "Delivery Service",
  "Courier Company",
  "Moving Company",
  "Home Maintenance Company",
  "Smart Home Solutions Provider",
  "Digital Transformation Company",
  "Blockchain Company",
  "Gaming Company",
  "Media Company",
  "Publishing Company",
  "Streaming Platform",
  "Healthcare Technology Company",
  "EdTech Company",
  "PropTech Company",
  "LegalTech Company",
  "HRTech Company",
  "TravelTech Company",
  "Green Technology Company",
  "Robotics Company",
  "Drone Services Company",
  "Research & Development Company",
  "Investment Firm",
  "Venture Capital Firm",
  "Private Equity Firm",
  "Wealth Management Company",
  "Stock Brokerage Company",
  "Cryptocurrency Company",
  "Payment Solutions Provider",
  "Telecommunications Provider",
  "Internet Service Provider",
  "Data Center Company",
  "Managed Services Provider",
  "Enterprise Software Company",
  "Customer Experience Company",
  "Lead Generation Company",
  "Sales Enablement Company",
  "Business Intelligence Company",
  "Automation Platform Provider",
  "AI-Powered Business Solutions Company"
];
